import { Grid, Link } from "@mui/material";
import React, { useState, useEffect } from "react";
import { addConfirm, addError, freshDeskReport, getCyGetInfo, getNameChangeUrl, getShopifyGetInfo, ga4Event, removeErrorConfirm, useBreakpoints } from "../../utils/generaFunctions";
import { Title } from "../../components/title/title.component";
import "./my-account.styles.scss";
import MtmButton from "../../components/mtm-button/mtm-button.component";
import MtmInputCalendar from "../../components/mtm-input-calendar/mtm-input-calendar.component";
import { changeCustomField, checkInfo } from "../../utils/recurly.functions";

export const MyAccount = (props) => {

    //Query string variables
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.has('email') ? urlParams.get('email') : "";
    const address = urlParams.has('address') ? urlParams.get('address') : "";
    const [userName, setUserName] = useState(""); 

    //variables
    const [wedDate, setWedDate] = useState("");
    const [subsDetailUrl, setSubsDetailUrl] = useState("");
    const [shopBalance, setShopBalance] = useState(0);
    const [pendingBalance, setPendingBalance] = useState(0);
    const [shopLink, setShopLink] = useState("");
    const [shopBtnText, setShopBtnText] = useState("");
    const [nameChangeLink, setNameChangeLink] = useState("");
    const [nameChangeBtnText, setNameChangeBtnText] = useState("download");

    //Constructor
    useEffect(()=>{
        if(!email || !address) {
            window.setLoginWindow(true);
        } else {
            checkInfo(email,address).then((respRecurly)=>{
                
                if(respRecurly.check){
                    setUserName(respRecurly.name);
                    if(respRecurly.wed_date) setWedDate(respRecurly.wed_date);
                    console.log("recurly_addons = " + respRecurly.addons);
                    if (respRecurly.token) {
                        setSubsDetailUrl("https://misstomrsbox.recurly.com/account/" + respRecurly.token);
                    }
                    if (!respRecurly.addons.includes("firstboxbundle") && !respRecurly.addons.includes("promo-namechange") && respRecurly.box_seq && !respRecurly.plan_code.includes("-otb-")) {
                        setNameChangeBtnText("Activated after your last box");
                    } else if (address.substring(0, 2) !== "US" && address.substring(0, 2) !== "CA") {
                        setNameChangeBtnText("Available in the US and Canada");
                    } else {
                        getNameChangeUrl(address).then((respNameChange)=>{
                            setNameChangeLink(respNameChange.url);
                        });
                    }

                    //shop balance
                    getCyGetInfo(email).then((respCy)=>{
                        if (respCy.balance >= 0) {
                            setShopBalance(respCy.balance);
                            console.log("shop_balance = " + respCy.balance);
                            //shopify
                            getShopifyGetInfo(email).then((respShopify)=>{
                                const customers = respShopify.customers;
                                if (customers.length > 0) {
                                    console.log("shopify_state = " + customers[0].state);
                                } else {
                                    console.log("shopify_state = null");
                                }
                                if(respCy.balance == null){
                                    console.log("no balance set")
                                } else if (respCy.balance  >= 0 && customers[0].state !== "enabled"){
                                    setShopBtnText("activate shop credit");
                                    setShopLink("https://shop.misstomrsbox.com/account/register?contact="+ encodeURIComponent(email));
                                } else if (respCy.balance >= 0 && customers[0].state === "enabled"){
                                    setShopBtnText("shop now");
                                    setShopLink("https://shop.misstomrsbox.com/account/login?contact="+ encodeURIComponent(email));
                                } else {
                                    setShopBtnText("shop now");
                                    setShopLink("https://shop.misstomrsbox.com/account/login?contact="+ encodeURIComponent(email));
                                }  
                                if(!respCy.balance) setShopBalance(0);
                                if(respCy.balance>=0 && respRecurly.addons && respRecurly.addons.includes("shopcredit-")){
                                    var pending_amount = 0;
                                    const addonArray = respRecurly.addons.split(",");
                                    addonArray.forEach(addon => {
                                        if(addon.includes('shopcredit-')){
                                            pending_amount += parseInt(addon.replace(/[^0-9]/g,''));
                                        }
                                    });
                                    setPendingBalance(pending_amount);
                                } else {
                                    setShopBtnText("");
                                    setShopLink("");
                                } 
                            })
                        } else {
                            console.log("shop_balance = null");
                        }
                    });
                } else {
                    window.setLoginWindow(true);
                }
            })
        }
    },[])
    return (
        <div className="my-account-container">
            <Grid container className="content-container" spacing={7} xs={12}>
                <Grid item className="text-roman content-title" xs={12}>Exclusive Offers & Deals</Grid>
                    <Grid item container xs={12} spacing={2} className="manage-container" justifyContent={"center"} id="exclusive-offer">
                        <Grid item container xs={12} md={5}  lg={3.2} xl={2.4} className="img-card">
                            <Grid item container className="account-card" xs={12} spacing={1} justifyContent={"center"}>
                                <Title
                                    img="yes" 
                                    src={require('../../imgs/account_offer1.jpg')}
                                    alt="shop_logo" 
                                    style={{width: '100%'}}
                                ></Title>
                                <Grid item className="text-roman content-title" xs={12}>ULTIMATE GROOM BOX</Grid>
                                <Grid item className="text-roman content-description" xs={12}>
                                    The perfect groom gift. Up to $200 value!
                                </Grid>
                                <Grid item display="flex" alignItems="end">
                                    <Link href={`/groom-box/?email=${email}&username=${userName}`} sx={{width:"100%", borderBottom:"0!important"}} target="_blank">
                                        <MtmButton text="LEARN MORE" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} md={5} lg={3.2} xl={2.4} className="img-card">
                            <Grid item container className="account-card" xs={12}  spacing={1} justifyContent={"center"}>
                                <Title
                                    img="yes" 
                                    src={require('../../imgs/account_offer2.jpg')}
                                    alt="shop_logo" 
                                    style={{width: '100%'}}
                                ></Title>
                                <Grid item className="text-roman content-title" xs={12}>EMBROIDERED BRIDE JACKET</Grid>
                                <Grid item className="text-roman content-description" xs={12}>
                                    Personalized with your last name and special date!
                                </Grid>
                                <Grid item display="flex" alignItems="end">
                                    <Link href={`/bride-jacket/?email=${email}&username=${userName}`} sx={{width:"100%", borderBottom:"0!important"}} target="_blank">
                                        <MtmButton text="LEARN MORE" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} md={5} lg={3.2} xl={2.4} className="img-card">
                            <Grid item container className="account-card" xs={12}  spacing={1} justifyContent={"center"}>
                                <Title
                                    img="yes" 
                                    src={require('../../imgs/account_offer3.jpg')}
                                    alt="shop_logo" 
                                    style={{width: '100%'}}
                                ></Title>
                                <Grid item className="text-roman content-title" xs={12}>EMBROIDERED BRIDE SET</Grid>
                                <Grid item className="text-roman content-description" xs={12}>
                                    The ultimate bride set, personalized to perfection.
                                </Grid>
                                <Grid item display="flex" alignItems="end">
                                    <Link href={`/bride-set/?email=${email}&username=${userName}`} sx={{width:"100%", borderBottom:"0!important"}} target="_blank">
                                        <MtmButton text="LEARN MORE" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} md={5} lg={3.2} xl={2.4} className="img-card">
                            <Grid item container className="account-card" xs={12}  spacing={1} justifyContent={"center"}>
                                <Title
                                    img="yes" 
                                    src={require('../../imgs/account_offer4.jpg')}
                                    alt="shop_logo" 
                                    style={{width: '100%'}}
                                ></Title>
                                <Grid item className="text-roman content-title" xs={12}>GIRLFRIEND TO FIANCÉE PJS</Grid>
                                <Grid item className="text-roman content-description" xs={12}>
                                    Look classy, feel comfy
                                </Grid>
                                <Grid item display="flex" alignItems="end">
                                    <Link href={`/pj-set/?email=${email}&username=${userName}`} sx={{width:"100%", borderBottom:"0!important"}} target="_blank">
                                        <MtmButton text="LEARN MORE" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} md={5} lg={3.2} xl={2.4} className="img-card">
                            <Grid item container className="account-card" xs={12}  spacing={1} justifyContent={"center"}>
                                <Title
                                    img="yes" 
                                    src={require('../../imgs/account_offer5.jpg')}
                                    alt="shop_logo" 
                                    style={{width: '100%'}}
                                ></Title>
                                <Grid item className="text-roman content-title" xs={12}>EMBROIDERED COUPLE SETS</Grid>
                                <Grid item className="text-roman content-description" xs={12}>
                                    Happily ever after starts here.
                                </Grid>
                                <Grid item display="flex" alignItems="end">
                                    <Link href={`/wifey-hubby/?email=${email}&username=${userName}`} sx={{width:"100%", borderBottom:"0!important"}} target="_blank">
                                        <MtmButton text="LEARN MORE" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                <Grid item className="text-roman content-title" xs={12} style={{paddingBottom:"10px"}}>account management & tracking</Grid>
                <Grid item container className="manage-container" xs={12} spacing={2} justifyContent={"center"} >
                    <Grid item container xs={12} md={6}>
                        <Grid item container className="account-card" xs={12} gap={2} justifyContent={"center"}>
                            <Grid item className="text-roman content-title" xs={12}>Subscription details</Grid>
                            <Grid item className="text-roman content-description" xs={12}>
                                View your plan, update payment/billing details, or check the next payment date. Note: To update your Shipping Address, contact the <Link href="/contact-us/">Customer Support Team.</Link>
                            </Grid>
                            <Grid item>
                                <Link href={subsDetailUrl} target="_blank">
                                    <MtmButton text="open" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Account Management & Tracking","Subscription Details Button Clicked",email)}}></MtmButton>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6}>
                        <Grid item container className="account-card" xs={12} gap={2} justifyContent={"center"}>
                            <Grid item className="text-roman content-title" xs={12}>TRACK MY BOX</Grid>
                            <Grid item className="text-roman content-description" xs={12}>
                            View the latest tracking info, check unexpected delays, or view proof of delivery. Use tracking number you received in the email
                            </Grid>
                            <Grid item>
                                <Link href="https://mtmbox.aftership.com/" target="_blank">
                                    <MtmButton text="track the box" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Account Management & Tracking","Track My Box Button Clicked",email)}}></MtmButton>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item container className="account-card" xs={12} justifyContent={"center"}>
                            <Grid container item xs={12} md={6} gap={1} sx={{textAlign:"left"}}>
                                <Grid item className="text-roman content-title" xs={12}>wedding date information</Grid>
                                <Grid item className="text-roman content-description" xs={12}>Enter your wedding date</Grid>
                            </Grid>
                            <Grid container item xs={12} md={6} spacing={1}>
                                <Grid item xs={6}>
                                    <MtmInputCalendar value={wedDate} onChange={(e)=>{setWedDate(e.target.value); removeErrorConfirm();}} id="wedding_date" label="Wedding Date"></MtmInputCalendar>   
                                </Grid>
                                <Grid item xs={6}>
                                    <MtmButton text="enter" sx={{height:"44px", marginTop:"0"}} onClick={()=>{
                                        changeCustomField(email,"wed_date", wedDate).then((response)=>{
                                            const element = document.getElementById("wedding_date").parentNode.parentNode.parentNode;
                                            if(response.success) {
                                                addConfirm(element, "Wedding date changed");
                                                freshDeskReport(email,userName, `wedding date changed to ${wedDate}`, "Sys: WD Updated", "Sys: WD Updated");
                                                ga4Event("my_account","Account Management & Tracking","Wedding Date Changed",`${email}, changed to ${wedDate}`);
                                            } else {
                                                addError(element, "Wedding date change failed");
                                                ga4Event("my_account","Account Management & Tracking","Wedding Date Change Failed",email);
                                            }
                                        })}}></MtmButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} sx={{display:!shopBtnText&&!shopLink&&!pendingBalance?"none":""}}>
                        <Grid item container className="account-card" xs={12} justifyContent={"center"}>
                            <Title
                                img="yes" 
                                src={require('../../imgs/shop_logo2.png')}
                                alt="shop_logo" 
                                style={{width: '150px', marginBottom:"15px"}}
                            ></Title>
                            <Grid container item xs={12} md={6} spacing={1} sx={{textAlign:"left", paddingRight:"15px"}}>
                                <Grid item className="text-roman content-title" xs={12}>Shop credit balance</Grid>
                                <Grid container item spacing={0} xs={12}>
                                    <Grid item className="text-roman content-description" xs={5} md={4}>Available now</Grid>
                                    <Grid item xs={5} md={6} sx={{borderStyle:"none none dotted", height:"20px"}}></Grid>
                                    <Grid item className="text-roman content-description" xs={2} sx={{textAlign:"right"}}>$ {shopBalance}</Grid>
                                    <Grid container item spacing={0} xs={12} sx={{opacity:"0.4", display:pendingBalance?"":"none"}}>
                                        <Grid item className="text-roman content-description" xs={4} md={2}>Pending*</Grid>
                                        <Grid item xs={6} md={8} sx={{borderStyle:"none none dotted", height:"20px"}}></Grid>
                                        <Grid item className="text-roman content-description" xs={2} sx={{textAlign:"right"}}>$ {pendingBalance}</Grid>
                                        <Grid item className="text-roman content-sub" xs={12}>
                                            *will become available as soon as your next box is shipped
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} md={6} gap={1} sx={{textAlign:"left", borderLeft:"2px solid var(--color-primary)", paddingLeft:"15px"}}>
                                <Grid item className="text-roman content-description" xs={12}>
                                    To redeem your shop credit please login to your account on Miss To Mrs Shop and then checkout using shop credit. Accumulate credit towards larger purchases and bigger discounts. <Link target="_blank" href="/terms-conditions/">Terms & Conditions</Link> apply.
                                </Grid>
                            </Grid>
                            <Grid item sx={{display:shopBtnText?"":"none"}}>
                                <Link href={shopLink} borderBottom="0!important" width="100%" target="_blank">
                                    <MtmButton text={shopBtnText} sx={{height:"44px", marginTop:"20px", width:"230px"}} onClick={()=>{}}></MtmButton>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className="text-roman content-title" xs={12}  style={{paddingTop:0}}>Wedding planning made easy</Grid>
                <Grid item container className="manage-container" xs={12} spacing={2} justifyContent={"center"} >
                    <Grid item container xs={12} md={6}>
                        <Grid item container className="account-card" xs={12} justifyContent={"center"} gap={1}>
                            <Title
                                img="yes" 
                                src={require('../../imgs/account_member1.png')}
                                alt="shop_logo" 
                                style={{width: '100%'}}
                            ></Title>
                            <Grid item className="text-roman content-title" xs={12}>TOOLS AND TEMPLATES</Grid>
                            <Grid item className="text-roman content-description" xs={12}>
                                Get all the tools you need in one place. Track your budget and vendors, design a custom timeline, and create seating plans and to-do lists.
                            </Grid>
                            <Grid item display="flex" alignItems="end">
                                <Link href={`/wedding-planning-essentials/?utm_source=misstomrsbox&utm_medium=Referrer&utm_campaign=WEB-MTM-Organic-MyAccount&email=${email}&address=${address}`} borderBottom="0!important" width="100%" target="_blank">
                                    <MtmButton text="get started" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Tools and Templated Button Clicked",`${email}`)}}></MtmButton>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6}>
                        <Grid item container className="account-card" xs={12} justifyContent={"center"}>
                            <Title
                                img="yes" 
                                src={require('../../imgs/account_member4.png')}
                                alt="shop_logo" 
                                style={{width: '100%'}}
                            ></Title>
                            <Grid item className="text-roman content-title" xs={12}>NAME CHANGE KIT</Grid>
                            <Grid item className="text-roman content-description" xs={12}>
                                A state-specific 60+ page Print-At-Home kit with instructions, checklists, & forms for hassle-free name change process.
                            </Grid>
                            <Grid item display="flex" alignItems="end">
                                <Link href={nameChangeLink} sx={{opacity:nameChangeBtnText==="download"?"":"0.4", pointerEvents:nameChangeBtnText==="download"?"":"none", width:"100%", borderBottom:"0!important"}} target="_blank">
                                    <MtmButton text={nameChangeBtnText} sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={()=>{ga4Event("my_account","Wedding Planning Made Easy","Name Change Kit Button Clicked",`${email}`)}}></MtmButton>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}